<div class="shop-page-info-image">
  <div
    class="image-tile"
    [reactComponent]="imageTileComponent"
    [props]="{
      translate: translateReference,
      imgUrl: logoSrc,
      altText: shop.name + ' logo',
      overlayText: shop?.disabledText,
      bottomOverlayText: hasTakeAwayLabel ? 'Take Away' : null
    }"
  ></div>
</div>
<div class="shop-page-info-content">
  <div class="shop-page-info-rating-and-tag">
    <shop-rating
      [shop]="shop"
      [showCounter]="true"
      (click)="onOpenDetails('SHOP_REVIEWS')"
      (keydown.enter)="onOpenDetails('SHOP_REVIEWS')"
      (keydown.space)="onOpenDetails('SHOP_REVIEWS')"
      role="button"
      tabindex="0"
      class="shop-page-info-shop-rating"
      aria-label="Shop rating"
    ></shop-rating>
    <span *ngIf="shop.daas" class="shop-page-info-tag">Delivery By BOX</span>
  </div>
  <div
    class="shop-page-info-header"
    (click)="onOpenDetails('SHOP_DETAILS')"
    (keydown.enter)="onOpenDetails('SHOP_DETAILS')"
    (keydown.space)="onOpenDetails('SHOP_DETAILS')"
    role="button"
    tabindex="0"
    aria-label="View shop information"
  >
    <h1 class="shop-page-info-header-title">{{ shop.name }}</h1>
    <mat-icon class="shop-page-info-header-icon" fontSet="material-icons-round">info_outline</mat-icon>
  </div>
  <p class="shop-page-info-cuisine-text">{{ shop.cuisinesText }}</p>
</div>
